import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import AdminHeader from '../../../common_components/admin_module_header';
import Footerlogin from '../../../common_components/Footerlogin';
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { selectApplication_action } from "../../../actions/exhibitor_module_actions/select_application_action/select_application_action"
import { toastError, toastSuccess, link_BASE_URL } from "../../../utils/constants"
import ApplicationHeader from "../../../common_components/application_header";


class SelectApplication extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            selectApplicationList: [],
        }
        this.handleView = this.handleView.bind(this)
        this.getSelectApplication = this.getSelectApplication.bind(this)
        this.onAddApplication = this.onAddApplication.bind(this)
    }


    componentDidMount() {
        this.getSelectApplication()
    }

    // get SelectApplication
    getSelectApplication() {
        this.setState({ isLoading: true })

        console.log("ooooooooooooooooooooooooooooooooooooo", sessionStorage.getItem("RoleIDSS",))
        this.props.selectApplication_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("get APplication-----------", data.data)
                    if (data.data.length == 1) {
                        // sessionStorage.setItem("ApplicationDataSS", JSON.stringify(data.data[0]))
                        // sessionStorage.setItem('ServiceIDSS', data.data[0]['ServiceID'])
                        // sessionStorage.setItem('ExhRegistrationIDSS', data.data[0]['ExhRegistrationID'])
                        // sessionStorage.setItem('ExhRegistrationNo', data.data[0]['ExhRegistrationNo'])
                        // sessionStorage.setItem('CurrencyID', data.data[0]['CurrencyID'])
                        // this.props.navigate('/exhibitor_dashboard')
                    }
                    if (data.data.length > 0) {
                        sessionStorage.setItem('isPaidByAgentRegistration', data.data[0]['ISPaidByAgentRegistration'] ? true : false)
                        sessionStorage.setItem('isAgentRegistered', data.data[0].AgentID != null && data.data[0].AgentID != '' ? true : false)
                    }
                    this.setState({ selectApplicationList: data.data, isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    handleView(id, data) {
        if (data.StatusID == 1) {
            var url = `${link_BASE_URL}registration/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        } else if (data.StatusID == 2) {
            var url = `${link_BASE_URL}primary_chapter/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        }
        else if (data.StatusID == 3) {
            var url = `${link_BASE_URL}primary_chapter/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        } else {
            if (JSON.parse(sessionStorage.getItem('loginDataSS')) != null) {
                var loginDataSS = JSON.parse(sessionStorage.getItem('loginDataSS'))
                loginDataSS.CountryID = data.CountryID
                loginDataSS.City = data.City
                loginDataSS.MobileNo = data.MobileNo
                sessionStorage.setItem('loginDataSS', JSON.stringify(loginDataSS))
            }
            sessionStorage.setItem("ApplicationDataSS", JSON.stringify(data))
            sessionStorage.setItem('ServiceIDSS', data.ServiceID)
            sessionStorage.setItem('ExhRegistrationIDSS', data.ExhRegistrationID)
            sessionStorage.setItem('ExhRegistrationNo', data.ExhRegistrationNo)
            sessionStorage.setItem('isPaidByAgentRegistration', data.ISPaidByAgentRegistration ? 1 : 0)
            this.props.navigate('/exhibitor_dashboard', { state: { serviceId: id } })
        }
    }

    onAddApplication() {
        var url = `${link_BASE_URL}registration/#&${sessionStorage.getItem('userEmailSS').trim()}#&${sessionStorage.getItem('exhibitionCode')}`;
        const win = window.open(url, '_blank', 'noopener,noreferrer');
        if (win != null) {
            win.focus();
        }
    }

    render() {
        const { isLoading, selectApplicationList } = this.state
        console.log(JSON.parse(sessionStorage.getItem('loginDataSS')).CountryID)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ApplicationHeader />
                {/* <AdminHeader /> */}
                <div className="row m-0"><div className="breadcrumb-scroll-fixed px-2"><h6 className="mb-0 p-2 text-white px-2">Choose your Application</h6></div></div>
                {/* <div className="container-fluid">
                    <div className="row">
                        <div className="breadcrumb-scroll-fixed">  
                            <h6 className="mb-0 p-2 text-white">Choose your Application</h6>
                        </div>
                    </div>
                </div> */}
                <div className="container-fluid exb-top-space-2 p-0 px-3" style={{marginBottom:'10rem'}}>
                    <div className="row ">
                        {selectApplicationList.length > 0 && selectApplicationList.map(data => (
                            data.StatusID < 4 ? sessionStorage.getItem("isAgentRegistered") == 'true' ? sessionStorage.getItem("isPaidByAgentRegistration") == 'false' ?
                                <div className="col-md-3 ">
                                    <div
                                        className="select-app  text-left mb-3"
                                        style={{ paddingBottom: "0px !important" }}
                                    >
                                        <div className="app-single-row app-no  border-bottom pb-2" style={{
                                            background: data.StatusID < 4 && "#4ec7be",
                                        }}>
                                            <p className="mb-0 text-white">Application Ref#</p>
                                            <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                                {data.ExhRegistrationNo}
                                            </h5>
                                        </div>
                                        <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                            <p className="mb-0">Booth Area (m2)</p>
                                            <h5 className="mb-0" style={{ color: "#222" }}>
                                                {data.StallArea}-{data.StallTypeName}
                                            </h5>
                                        </div>
                                        <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                            <p className="mb-0">Main Category</p>
                                            <h5 className="mb-0" style={{ color: "#222" }}>
                                                {data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}
                                            </h5>
                                        </div>
                                        <div className="app-single-row mt-2 px-2  border-bottom pb-2" style={{ borderBottom: "none" }}>
                                            <p className="mb-0">Booking Status</p>
                                            <h5 className="mb-0" style={{ color: data.StatusID < 4 ? "#222" : "#222" }}>
                                                {data.StatusID < 4 ? 'Incomplete' : 'Applied'}
                                            </h5>
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                                style={{
                                                    background: data.StatusID < 4 ? '#4ec7be' : "#4ec7be",
                                                }}
                                                onClick={(e) => this.handleView(data.ServiceID, data)}
                                            >
                                                {data.StatusID < 4 ? 'Resume Application' : 'View Application'}
                                            </button>
                                        </div>
                                    </div>
                                </div> : sessionStorage.getItem("isIndirectAccess") == 'true' ?
                                    <div className="col-md-3 ">
                                        <div
                                            className="select-app  text-left mb-3"
                                            style={{ paddingBottom: "0px !important" }}
                                        >
                                            <div className="app-single-row app-no  border-bottom pb-2" style={{
                                                background: data.StatusID < 4 && "#4ec7be",
                                            }}>
                                                <p className="mb-0 text-white">Application Ref#</p>
                                                <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                                    {data.ExhRegistrationNo}
                                                </h5>
                                            </div>
                                            <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                                <p className="mb-0">Booth Area (m2)</p>
                                                <h5 className="mb-0" style={{ color: "#222" }}>
                                                    {data.StallArea}-{data.StallTypeName}
                                                </h5>
                                            </div>
                                            <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                                <p className="mb-0">Main Category</p>
                                                <h5 className="mb-0" style={{ color: "#222" }}>
                                                    {data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}
                                                </h5>
                                            </div>
                                            <div className="app-single-row mt-2 px-2  border-bottom pb-2" style={{ borderBottom: "none" }}>
                                                <p className="mb-0">Booking Status</p>
                                                <h5 className="mb-0" style={{ color: data.StatusID < 4 ? "#222" : "#222" }}>
                                                    {data.StatusID < 4 ? 'Incomplete' : 'Applied'}
                                                </h5>
                                            </div>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                                    style={{
                                                        background: data.StatusID < 4 ? '#4ec7be' : "#4ec7be",
                                                    }}
                                                    onClick={(e) => this.handleView(data.ServiceID, data)}
                                                >
                                                    {data.StatusID < 4 ? 'Resume Application' : 'View Application'}
                                                </button>
                                            </div>
                                        </div>
                                    </div> : <></> : <div className="col-md-3 ">
                                <div
                                    className="select-app  text-left mb-3"
                                    style={{ paddingBottom: "0px !important" }}
                                >
                                    <div className="app-single-row app-no  border-bottom pb-2" style={{
                                        background: data.StatusID < 4 && "#4ec7be",
                                    }}>
                                        <p className="mb-0 text-white">Application Ref#</p>
                                        <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                            {data.ExhRegistrationNo}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                        <p className="mb-0">Booth Area (m2)</p>
                                        <h5 className="mb-0" style={{ color: "#222" }}>
                                            {data.StallArea}-{data.StallTypeName}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                        <p className="mb-0">Main Category</p>
                                        <h5 className="mb-0" style={{ color: "#222" }}>
                                            {data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2" style={{ borderBottom: "none" }}>
                                        <p className="mb-0">Booking Status</p>
                                        <h5 className="mb-0" style={{ color: data.StatusID < 4 ? "#222" : "#222" }}>
                                            {data.StatusID < 4 ? 'Incomplete' : 'Applied'}
                                        </h5>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                            style={{
                                                background: data.StatusID < 4 ? '#4ec7be' : "#4ec7be",
                                            }}
                                            onClick={(e) => this.handleView(data.ServiceID, data)}
                                        >
                                            {data.StatusID < 4 ? 'Resume Application' : 'View Application'}
                                        </button>
                                    </div>
                                </div>
                            </div> : <div className="col-md-3 ">
                                <div
                                    className="select-app  text-left mb-3"
                                    style={{ paddingBottom: "0px !important" }}
                                >
                                    <div className="app-single-row app-no  border-bottom pb-2" style={{
                                        background: data.StatusID < 4 && "#4ec7be",
                                    }}>
                                        <p className="mb-0 text-white">Application Ref#</p>
                                        <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                            {data.ExhRegistrationNo}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                        <p className="mb-0">Booth Area (m2)</p>
                                        <h5 className="mb-0" style={{ color: "#222" }}>
                                            {data.StallArea}-{data.StallTypeName}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2">
                                        <p className="mb-0">Main Category</p>
                                        <h5 className="mb-0" style={{ color: "#222" }}>
                                            {data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}
                                        </h5>
                                    </div>
                                    <div className="app-single-row mt-2 px-2  border-bottom pb-2" style={{ borderBottom: "none" }}>
                                        <p className="mb-0">Booking Status</p>
                                        <h5 className="mb-0" style={{ color: data.StatusID < 4 ? "#222" : "#222" }}>
                                            {data.StatusID < 4 ? 'Incomplete' : 'Applied'}
                                        </h5>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                            style={{
                                                background: data.StatusID < 4 ? '#4ec7be' : "#4ec7be",
                                            }}
                                            onClick={(e) => this.handleView(data.ServiceID, data)}
                                        >
                                            {data.StatusID < 4 ? 'Resume Application' : 'View Application'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {selectApplicationList.length > 0 ? sessionStorage.getItem("isAgentRegistered") == 'true' ? <></> : < div className="col-md-3 ">
                            <div
                                className="select-app  text-left mb-3 mt-4"
                                style={{ paddingBottom: "0px !important" }}
                            >
                                <div className="app-single-row app-no  border-bottom pb-2" style={{
                                    background: '#4ec7be',
                                }}>
                                    {/* <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </p> */}
                                    <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                        New Application
                                    </h5>
                                </div>
                                <div className="app-single-row mt-2 px-2 pb-2">
                                    {/* <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p> */}
                                    {/* <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p> */}
                                    <p className="mb-0 text-left text-dark" style={{ fontWeight: 500, fontSize: 'medium' }}>
                                        If you would like to submit another application for this exhibition,
                                        <br />
                                    </p>
                                    {/* <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p> */}
                                    <span className="mt-2 text-dark mt-2" style={{ fontWeight: 500, fontSize: 'medium' }}>
                                        Please click the button below.
                                    </span>
                                </div>
                                <div className="app-single-row mt-1 px-2   pb-1">
                                </div>
                                <div className="app-single-row mt-2 px-2 pb-2" style={{ borderBottom: "none" }}>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                        style={{
                                            background: '#4ec7be',
                                        }}
                                        onClick={(e) => this.onAddApplication()}
                                    >
                                        New Application
                                    </button>
                                </div>
                            </div>
                        </div> : <div className="col-md-3 ">
                            <div
                                className="select-app  text-left mb-3"
                                style={{ paddingBottom: "0px !important" }}
                            >
                                <div className="app-single-row app-no  border-bottom pb-2" style={{
                                    background: '#4ec7be',
                                }}>
                                    <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </p>
                                    <h5 className="mb-0 text-left text-white" style={{ color: "#4ec7be" }}>
                                        New Application
                                    </h5>
                                </div>
                                <div className="app-single-row mt-2 px-2 pb-2">
                                    <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                    <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                    <p className="mb-0 text-left text-dark" style={{ fontWeight: 500, fontSize: 'medium' }}>
                                        It seems that you dont have any application submitted for this Exhibition Yet.
                                        <br />
                                    </p>
                                    <p className="mb-0 text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                    <span className="mt-2 text-dark" style={{ fontWeight: 500, fontSize: 'medium' }}>
                                        Please click the button below.
                                    </span>
                                </div>
                                <div className="app-single-row mt-1 px-2   pb-1">
                                </div>
                                <div className="app-single-row mt-2 px-2 pb-2" style={{ borderBottom: "none" }}>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-light text-white mt-3 w-100 d-block application-btn py-3"
                                        style={{
                                            background: '#4ec7be',
                                        }}
                                        onClick={(e) => this.onAddApplication()}
                                    >
                                        New Application
                                    </button>
                                </div>
                            </div>
                        </div>}
                    </div>
                    {/* <div className="row p-3">
                        <a href="#">
                            <button
                                type="button"
                                className="btn btn-outline-light text-dark mt-3"
                                style={{
                                    background: "#f2e9e5",
                                    width: "24%",
                                    borderRadius: 0,
                                    border: "1px solid #eb7520",
                                    marginLeft: "-13px"
                                }}
                            >
                                Additional Stall Registration
                            </button>
                        </a>
                    </div> */}
                </div >
                <Footerlogin />
            </>

        )
    }
}



export default withRouter(connect(null, { selectApplication_action })(SelectApplication));